<template>
  <div class="inner-box">
    <form>
      <div class="content-name">
        <h2 class="dp-ib">{{ title }}</h2>
        <div class="btn-wrap btn-type1 clearfix">
          <button type="button" class="btn-size btn-blue fl_left" @click="addBoard()">
            <span class="btn-icon"><i class="fas fa-save"></i></span>
            저장
          </button>
        </div>
      </div>
    </form>
    <!-- TABLE  -->
    <div class="table-area">
      <div class="table-a">
        <div class="table-name">
          <h3 class="ico_table_name">글쓰기</h3>
        </div>
        <table class="table">
          <colgroup>
            <col width="25%;">
            <col width="85%;">
          </colgroup>
          <tbody>
            <tr style="height:5vh;">
              <th>작성자</th>
              <td>{{ this.$store.state.loginInfo.userName }}</td>
            </tr>
            <tr v-if="boardCd=='21'" style="height:5vh;">
              <th>공지 등록</th>
              <td>
                <div class="td-flex">
                  <input type="checkbox" id="notic" v-model="form.bPopupFlag"/><label for="notic" class="cuTable-chk">&nbsp;&nbsp;&nbsp;&nbsp; 등록&nbsp;&nbsp;</label> 
                  <div v-if="form.bPopupFlag==true" style="display:flex;">
                    /&nbsp;&nbsp; 기간 : &nbsp;&nbsp;
                    <div class="datepicker w-type-ymd02">
                      <dhx-calendar class="input ddate sDate" v-model="form.bPopupSdate" />
                    </div>
                    <span class="wave">&nbsp; ~ &nbsp;</span>
                    <div class="datepicker w-type-ymd02">
                      <dhx-calendar class="input ddate sDate" v-model="form.bPopupEdate" />
                    </div>
                  </div>
                </div>
                                
              </td>
            </tr>
            <tr v-if="boardCd=='11'" style="height:5vh">
              <th>분류</th>
              <td>
                <b-select class="select is-fullwidth" style = "width:30%;" v-model="form.boardSubCd">
                  <option value="">==선택==</option>
                  <option
                    v-for="item in boardSub"
                    :key="item.key"
                    :value="item.key"
                    v-text="item.value"/>
                </b-select>
              </td>
            </tr>
            <tr v-if="boardCd=='11'" style="height:5vh">
              <th>제품군</th>
              <td>
                <b-select class="select is-fullwidth" style = "width:30%;" v-model="form.attribute5">
                  <option value="">==선택==</option>
                  <option
                    v-for="item in product"
                    :key="item.key"
                    :value="item.key"
                    v-text="item.value"/>
                </b-select>
              </td>
            </tr>
            <tr v-if="boardCd=='22'" style="height:5vh;">
              <th>건의유형</th>
              <td>
                <b-select class="select is-fullwidth" style = "width:30%;" v-model="form.attribute1">
                  <option value="">==선택==</option>
                  <option
                    v-for="item in boardSug"
                    :key="item.key"
                    :value="item.key"
                    v-text="item.value"/>
                </b-select>
              </td>
            </tr>
            <tr v-if="boardCd=='22'" style="height:5vh;">
              <th>세부유형</th>
              <td>
                <b-select class="select is-fullwidth" style = "width:30%;" v-model="form.attribute2">
                  <option value="">==선택==</option>
                  <option
                    v-for="item in boardSugDetail"
                    :key="item.detailCd"
                    :value="item.detailCd"
                    v-text="item.detailNm"/>
                </b-select>
              </td>
            </tr>
            <tr style="height:5vh;">
              <th>첨부파일</th>
              <td>
                <div class="scan-item02">        
                  <div class="btn-wrap btn-type1" style = "margin-bottom:0px; margin-left:10px;">
                    <input type="file" ref="file" @change="proceedFileUpload()" style="display:none;" multiple/>
                    <button type="button" class="btn-size btn-gray fl_left" @click="startFileUpload()">
                      파일찾기
                    </button>
                    <!-- <button type="button" class="btn-size btn-orange fl_left">
                                            삭제
                                        </button> -->
                  </div>
                  <div class="scan-desc">
                    <ul>
                      <li v-for="(file, index) in read_files" :key="index" style="display:flex;">
                        <article @click="toggle(file, file.chk = !file.chk)">
                          <div class="content">
                            <p class="name-tit">{{ file.name || file.originalName }}</p>
                          </div>
                        </article>
                        <button style="padding-left: 10px;" @click="fileDelete(file)"><i class="far fa-trash-alt"></i></button>
                      </li>
                    </ul>
                  </div>                
                </div>      
              </td>
            </tr>
            <tr style="height:5vh;">
              <th>제목</th>
              <td>
                <input type="text" class="input" v-model="form.bSubject"/>
              </td>
            </tr>
            <tr style="height:50vh;">
              <th>내용</th>
              <td style="padding:0px 0px !important;">
                <vue-editor id="editor1" v-model="form.bContent" :editor-toolbar="customToolbar"/>
              </td>
            </tr>
                        
          </tbody>
        </table>
      </div>
    </div>
    <!-- TABLE  -->
  </div>    
</template>
<script>
import DhxCalendar from '@/components/Dhx/DhxCalendar.vue'

export default {
    name:'BoardWrite',
    components:{DhxCalendar},
    data(){
        return {
            title:'',
            boardCd:'',
            update:'',
            boardSub:[],
            boardSug:[],
            boardSugDetail:[],
            product:[],
            form:{
                id:'',
                boardCd:!this.$route.params.boardCd ? this.$store.state.board.boardCd : this.$route.params.boardCd,
                boardSubCd:'',
                bSubject:'',
                bContent:'',
                attribute1:'',
                attribute2:'',
                attribute5:'',
                bReply:'N',
                bPopupFlag: '',
                bPopupSdate: this.$moment().format('YYYYMMDD'),
                bPopupEdate: this.$moment().format('YYYYMMDD'),
            },
            attribute1_continer:'',
            file:'',
            a_files: [],
            read_files:[],
            removeFile:[],
            resp:'',
            customToolbar: [
                [{ font: [] }],
                [{ size: ["small", false, "large", "huge"] }],
                ["bold", "italic", "underline", "strike"],
                [
                    { align: "" },
                    { align: "center" },
                    { align: "right" },
                    { align: "justify" }
                ],
                [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
                [{ indent: "-1" }, { indent: "+1" }],
                [{ color: [] }, { background: [] }]
            ]
        }
    },
    watch: {
        'form.attribute1':{
            immediate: true,
            deep: true,
            handler(value) {
                this.getBoardSugDetailCombo(value);
                if(this.attribute1_continer != value)
                    this.form.attribute2='';
            }
            
        }
    },
    created(){
        this.title = this.$route.params.title;
        this.boardCd = this.$route.params.boardCd;
        if(this.$route.params.form){
            this.form = this.$route.params.form;
            this.attribute1_continer = this.form.attribute1
            this.update = this.$route.params.update;
            this.read_files = this.$route.params.file;
            if(this.$route.params.form.bPopupFlag=='Y'){
                this.form.bPopupFlag=true
            }
            if(this.$route.params.form.bPopupSdate == null){
                this.form.bPopupSdate = this.$moment().format('YYYYMMDD')
                this.form.bPopupEdate = this.$moment().format('YYYYMMDD')
            }
            
        }
        
    },
    mounted(){
        if(!this.boardCd){
            this.boardCd = this.$store.state.board.boardCd;
        }
        if(!this.title){
            this.title = this.$store.state.board.title;
        }
        this.getBoardSubCombo();
        this.getBoardSugCombo();
        this.getProductCombo()
        
        
    },
    methods:{
        startFileUpload() {
            // Trigger click event
            this.$refs.file.click()
        },
        proceedFileUpload() {
            let files = this.$refs.file.files
            //this.a_files.push(files)

            if(files.length >1){
             for(let i=0; i<files.length; i++){
                 this.read_files.push(files[i])
             }    
            }else{
                this.read_files.push(files[0])
            }
        },
        fileDelete(file){
            // for(let i=0; i<this.a_files.length; i++){
            //     if(this.a_files[i] === file){
            //         this.a_files.splice(i,1)
            //         console.log("a_files---",this.a_files);
            //     }
            // }
            for(let i=0; i<this.read_files.length; i++){
                if(this.read_files[i] === file){
                    this.read_files.splice(i,1)
                    console.log("read_files---",this.read_files);
                }
            }
            if(this.update && !file.name){
                this.$http.post('/api/board/file/removeFiles', {
                documentHId: file.documentHId,
                id: file.id
                }).then(response => {
                    this.removeFile =response.data
                })
            }
            

        },
        fileUplod(id){
            
            // Ok to proceed
            if (this.read_files.length > 0) {
                let form = new FormData()

                _.forEach(this.read_files, (file, i) => {
                    form.append(`files`, file)
                })
                /*
                _.forEach(this.a_files, (file, i) => {
                     _.forEach(file, (file_1, i) => {
                        form.append(`files`, file_1)
                    })
                    
                })
                */
                this.$store.commit('loading')
                this.$http.post(`/api/board/file/addFiles/${id}`, form, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
                }).then(response => {
                /*
                this.$swal({
                    type: 'success',
                    text: '파일이 업로드 되었습니다.'
                }).then(() => {
                    this.a_files = this.a_files.concat(response.data)
                })*/
                return response
                }).catch(response => {
                this.$swal({
                    type: 'error',
                    text: '파일업로드에 실패하였습니다.'
                })
                return response
                }).finally(() => {
                this.$store.commit('finish')
                })
            }
            
        },
        /**
         * 선택되었는지 체크
         */
        isSel(file) {
            return file.chk
        },
        /**
         * 선택 이벤트 핸들러
         */
        toggle(file, callback) {
            if (file.chk) {
                this.sel.unshift(file)
            } else {
                this.sel.splice(this.sel.indexOf(file), 1)
            }

            if (callback !== undefined && typeof callback === 'function') {
                callback.apply(this, [file])
            }
        },
        getBoardSubCombo() {
            this.$http.get(`/api/code/combo`, {params: {groupCd: "BOARD_SUB_CD"}})
                .then(response => {
                    this.boardSub = response.data;
                });
        },
        getBoardSugCombo() {
            this.$http.get(`/api/code/combo`, {params: {groupCd: "SUG_CD"}})
                .then(response => {
                    this.boardSug = response.data;
                });
        },
        getBoardSugDetailCombo(value) {
            this.$http.get(`/api/code/detail`, {params: {groupCd: "SUG_DETAIL_CD"}})
                .then(response => {
                    var sugDetailCd = response.data;
                    //console.log(this.form.attribute1)
                    this.boardSugDetail=sugDetailCd.filter(x => x.remark1 == value)
                    
                });
        },
        getProductCombo() {
            this.$http.get(`/api/code/combo`, {params: {groupCd: "JPRYU_CD"}})
                .then(response => {
                    this.product = response.data;
                });
        },
        addBoard(){
            if(this.boardCd == '11'){
                if(!this.form.boardSubCd){
                    this.$swal({type: 'warning', text: '분류를 지정해 주세요.'});
                    return false;
                }
                if(!this.form.attribute5){
                    this.$swal({type: 'warning', text: '제품군을 지정해 주세요.'});
                    return false;
                }
            }else if(this.boardCd == '22'){
                if(!this.form.attribute1){
                    this.$swal({type: 'warning', text: '건의유형을 지정해 주세요.'});
                    return false;
                }
                if(!this.form.attribute2){
                    this.$swal({type: 'warning', text: '세부유형을 지정해 주세요.'});
                    return false;
                }
                
            }
            if(!this.form.bSubject){
                this.$swal({type: 'warning', text: '제목을 입력해 주세요.'});
                return false;
            }
            if(!this.form.bContent){
                this.$swal({type: 'warning', text: '내용을 입력해 주세요.'});
                return false;
            }

            if(this.form.bPopupFlag){
                this.form.bPopupFlag ='Y'
                if(this.form.bPopupSdate.indexOf('-')||this.form.bPopupEdate.indexOf('-')){
                    this.form.bPopupSdate=this.form.bPopupSdate.replace(/\-/g,"")
                    this.form.bPopupEdate=this.form.bPopupEdate.replace(/\-/g,"")
                }
            }else{
                this.form.bPopupFlag =''
            }
           
            if(this.update){
                this.$http.put(`/api/board/updateBoardDetail/${this.form.id}`, this.form)
                .then(response=>{
                    console.log("업데이트")
                    this.resp = response.data;
                    this.fileUplod(this.resp.id);
                    this.$swal({
                        type: 'success',
                        text: '저장 되었습니다.'
                    }).then(() => {
                        if(this.boardCd == '11'){
                            this.$router.push({          
                                name: 'listSaleSupportGuide',
                            }) 
                        }else if(this.boardCd == '21'){
                            this.$router.push({          
                                name: 'ListNewsletter',
                            }) 
                        }else if(this.boardCd == '22'){
                            this.$router.push({          
                                name: 'ListSuggest',
                            }) 
                        }
                          
                    })
                })
            }else{
                this.$http.post(`/api/board/addBoard`, this.form)
                .then(response=>{
                    
                    console.log("신규저장")
                    this.resp = response.data;
                    this.fileUplod(this.resp.id);
                    this.$swal({
                        type: 'success',
                        text: '저장 되었습니다.'
                    }).then(() => {
                        if(this.boardCd == '11'){
                            this.$router.push({          
                                name: 'listSaleSupportGuide',
                            }) 
                        }else if(this.boardCd == '21'){
                            this.$router.push({          
                                name: 'ListNewsletter',
                            }) 
                        }else if(this.boardCd == '22'){
                            this.$router.push({          
                                name: 'ListSuggest',
                            }) 
                        }
                          
                    })
                })
            }
            
        }
    },
}
</script>
<style>
#editor1{
    height: 49vh;
    border: none;
}
</style>